import Actions from "../actions";
import { produce } from "immer";

const initialState = {
    walletManagement: {},
    selectedWalletManagementId:''
};


const walletManagement = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_WALLET_MANAGEMENT_LIST: {
      draft.walletManagement = payload?.walletManagement;
      break;
    }
    case Actions.SELECTED_WALLET_MANAGEMENT_ID: {
      draft.selectedWalletManagementId = payload?.selectedWalletManagementId;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default walletManagement;
